import { createContext } from "react";
import { Company } from "src/api/client-api/company/useGetOneOrganization.ts";
import { SsqVersion } from "src/api/sure-api/ssq/useGetOneSsqVersion.ts";

export type CompanyMetadataInit = {
    company: Company;
    ssqVersion: SsqVersion | undefined;
};
export const CompanyMetadataContext = createContext<CompanyMetadataInit | null>(null);
